/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaPiecemealSnapshotRequest model module.
 * @module model/AqaPiecemealSnapshotRequest
 * @version v0
 */
export default class AqaPiecemealSnapshotRequest {
  /**
   * Constructs a new <code>AqaPiecemealSnapshotRequest</code>.
   * @alias module:model/AqaPiecemealSnapshotRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaPiecemealSnapshotRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaPiecemealSnapshotRequest} obj Optional instance to populate.
   * @return {module:model/AqaPiecemealSnapshotRequest} The populated <code>AqaPiecemealSnapshotRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaPiecemealSnapshotRequest();
      if (data.hasOwnProperty('originalFilename'))
        obj.originalFilename = ApiClient.convertToType(data['originalFilename'], 'String');
      if (data.hasOwnProperty('sheetName'))
        obj.sheetName = ApiClient.convertToType(data['sheetName'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} originalFilename
 */
AqaPiecemealSnapshotRequest.prototype.originalFilename = undefined;

/**
 * @member {String} sheetName
 */
AqaPiecemealSnapshotRequest.prototype.sheetName = undefined;

